import AbstractGuestlistDetailsPageController from '../guestlists/abstract-details-controller';

export default class GuestlistRsvpsImportPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.locale = this.injector.get('locale');
        this.rsvpStore = this.injector.get('Rsvps').create();
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this._setupStore();
    }

    _setupStore() {
        this.rsvpStore.commit('setPrefix', 'guestlists/' + this.state.params.gid);
        this.rsvpStore.dispatch('getDefinitions')
            .then(() => {
                this.fields = _.keyBy(this.rsvpStore.state.columns, 'key');
            });
    }

    onSuccess() {
        this.state.go('app.guestlists.rsvps.index');
    }

    onFailure(response) {
        this.alert.error(this.locale.getString('sweetalerts.import_unsuccessful_title'), response.message);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/import-controller.js